<template>
	<div class="mt-minus-16 mb-24">
		<button
			v-if="show_form === false"
			class="button button--small"
			type="button"
			@click="show_form = !show_form"
		>
			Create a new {{ formTitle.toLowerCase() }}
		</button>
		<form
			v-else
			@submit.prevent="companyForm"
		>
			<div
				class="form__set form__set--wrap"
			>
				<InputComponent
					:value="localised_form_fields.title"
					type="text"
					input-id="title"
					name="title"
					:label="formTitle + ' name'"
					:required="true"
					:errors="localised_form_errors.title || null"
					@update:value="new_value => localised_form_fields.title = new_value"
				/>
				<InputComponent
					v-if="showShortCodeField"
					:value="localised_form_fields.company_short_code"
					type="text"
					input-id="company-short-code"
					name="company-short-code"
					label="Company short code"
					:required="true"
					:errors="localised_form_errors.company_short_code || null"
					@update:value="new_value => handleShortCodeInput( new_value )"
				/>
				<InputComponent
					:value="localised_form_fields.company_url"
					type="url"
					input-id="company-url"
					name="company-url"
					label="URL"
					:required="true"
					:errors="localised_form_errors.company_url || null"
					@update:value="new_value => localised_form_fields.company_url = new_value"
				/>
				<p
					v-if="company_form_errors"
					class="form__error pre-wrap"
				>
					{{ company_form_errors }}
				</p>
				<div class="flex flex--wrap flex--gap-large flex--align-center">
					<button
						class="button button--fill button--small"
						type="submit"
					>
						Add {{ formTitle.toLowerCase() }}
					</button>
					<button
						class="a a--no-underline a--small"
						type="button"
						@click="closeForm"
					>
						Cancel
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, defineProps, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const { createCompany } = new_project_store;
const {
	company_form_fields,
	company_form_errors
} = storeToRefs( new_project_store );

const localised_form_errors = ref( [] );
const localised_form_fields = ref( {
	title: '',
	company_url: '',
	company_short_code: ''
} );

const emit = defineEmits( ['refresh:companies'] );

const props = defineProps( {
	fieldHandle: {
		required: true,
		type: String,
		default: null
	},
	formTitle: {
		required: false,
		type: String,
		default: null
	},
	showShortCodeField: {
		required: false,
		type: Boolean,
		default: false
	}
} );

const show_form = ref( false );

async function companyForm() {
	company_form_errors.value = null;
	localised_form_errors.value = [];

	if ( Object.keys( localised_form_errors.value ).length > 0 ) {
		return;
	}
	if ( localised_form_fields.value.title !== '' ) {
		company_form_fields.value.title = localised_form_fields.value.title;
	}
	if ( localised_form_fields.value.company_url !== '' ) {
		company_form_fields.value.company_url = localised_form_fields.value.company_url;
	}
	if ( props.showShortCodeField ) {
		if ( localised_form_fields.value.company_short_code === '' ) {
			company_form_errors.value = 'Please enter a company short code';
			return;
		}

		company_form_fields.value.company_short_code = localised_form_fields.value.company_short_code;
	}

	await createCompany();
	if ( company_form_errors.value.length ) {
		return;
	}

	emit( 'refresh:companies', company_form_fields.value.title, props.fieldHandle );
	closeForm();
}

function handleShortCodeInput( value ) {
	localised_form_fields.value.company_short_code = value.toUpperCase();
}

function closeForm() {
	show_form.value = false;
	localised_form_fields.value.title = '';
	localised_form_fields.value.company_url = '';
	localised_form_fields.value.company_short_code = '';
	localised_form_errors.value = [];
	company_form_fields.value.title = '';
	company_form_fields.value.company_url = '';
	company_form_fields.value.company_short_code = '';
	company_form_errors.value = null;
}

</script>
